module.exports = __webpack_public_path__ + "img/lu.596ae902.svg";